import "./ag_grid"
import "./jquery"
import "./dashboard"
import "./fse_graphs"
import "./graphs"
import "./lcfs_dashboard_graphs"
import "./bootstrap_init"
import "./common"
import "./meter_readings"
import "./has_dependencies"
import "./confirmation_modal"
import "./controllers"
import "./has_dependent_input"
import "./jquery.form"
import "./jquery.has_dependent_select"
import "./jquery.iframe-transport"
import "./jquery.remotipart"
import "./jquery.spin"
import "./jquery.serialize_all"
import "./spin"

// Configure Bootstrap
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Configure Selectize
import * as selectize from "@selectize/selectize"
window.selectize = selectize
import "./selectize"

// Configure Cocoon
import "@nathanvda/cocoon"

// Configure Bootstrap Datepicker
import "bootstrap-datepicker"
import "./bootstrap_datepicker"

import { Config } from "./config"
window.Config = Config

import Chart from "chart.js/auto"
window.Chart = Chart

import Rails from "@rails/ujs"
Rails.start()
